import CrudRequest from '@/app/arch/components/crud/CrudRequest';
import httpService from '@/app/arch/services/HttpService';

export default class StoreRequest extends CrudRequest {
  static baseUrl() {
    return 'cliente/loja';
  }

  static list(params = {}) {
    return httpService.get(
      `${this.baseUrl()}/list-all`,
      {
        params,
      },
    );
  }

  static get(id) {
    return httpService.get(
      `${this.baseUrl()}/endDetalhes/${id}`,
    );
  }

  static closingStore(id, closing) {
    return httpService.put(`${this.baseUrl()}/habilitar-encerramento/${id}`, {
      params: {
        indHabilitar: closing,
      },
    });
  }

  static syncProducts(id) {
    return httpService.get(
      `produto-servico/template-produto-loja/sincroniza-produto/${id}`,
    );
  }

  static syncAddress(payload) {
    return httpService.post(
      'backofficeapi/sincronizar-sgv/endereco',
      payload,
    );
  }

  static syncStoreName(sgvClientId) {
    return httpService.post(
      'backofficeapi/sincronizar-sgv/razao-social',
      {
        sgvClientId,
      },
    );
  }

  static getInfoAntecipacao(storeId) {
    return httpService.get(
      'charge/antecipacao/pode-antecipar',
      {
        params: {
          storeId,
        },
      },
    );
  }
}
